import React from "react";
import SEO from "@/components/SEO";
import PageHero from "@/components/site/PageHero";

const sections = [
  { h: "1. Information We Collect", p: "We collect information you provide directly — such as your name, email, phone number and project details when you contact us or subscribe to our newsletter. We also collect limited technical data (IP address, browser type, pages visited) through standard analytics to improve our website." },
  { h: "2. How We Use Your Information", p: "We use your information to respond to enquiries, deliver our services, send relevant updates you've opted into, and improve our website and offerings. We never sell your personal data to third parties." },
  { h: "3. Cookies & Tracking", p: "Our website uses essential and analytics cookies to understand how visitors interact with our content. You can control cookies through your browser settings at any time." },
  { h: "4. Data Security", p: "We implement industry-standard safeguards — including encryption, access controls and secure infrastructure — to protect your information against unauthorised access, alteration or disclosure." },
  { h: "5. Your Rights", p: "You have the right to access, correct or delete your personal data, and to withdraw consent for marketing communications. To exercise these rights, contact us at hello@webvantagenterprises.com." },
  { h: "6. Third-Party Services", p: "We may use trusted third-party providers (such as analytics and email platforms) that process data on our behalf under strict confidentiality agreements." },
  { h: "7. Changes to This Policy", p: "We may update this Privacy Policy periodically. Material changes will be reflected by the 'Last updated' date below." },
];

export default function Privacy() {
  return (
    <>
      <SEO title="Privacy Policy" description="How Web Vantage Enterprises collects, uses and protects your personal information." path="/privacy" />
      <PageHero overline="Legal" title="Privacy Policy" subtitle="Last updated January 2026" crumbs={[{ label: "Privacy Policy" }]} />
      <section className="py-20 lg:py-28">
        <div className="container-wv max-w-3xl space-y-10">
          <p className="text-base leading-relaxed text-slate-400">
            At Web Vantage Enterprises, your privacy matters. This policy explains what data we collect, how we use it and the choices you have.
          </p>
          {sections.map((s) => (
            <div key={s.h}>
              <h2 className="font-heading text-xl font-semibold text-white">{s.h}</h2>
              <p className="mt-3 text-base leading-relaxed text-slate-400">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
